export const arraysAreEqual = <T>(
  arr1: T[],
  arr2: T[],
  elementEq: (a: T, b: T) => boolean = (a, b) => a === b
): boolean => {
  if (arr1.length !== arr2.length) {
    return false;
  }

  return arr1.every((value, index) => elementEq(value, arr2[index]));
};
